import React from 'react';
import type { LeadTemperature } from '../../services/crmService';

const styles: Record<
  LeadTemperature,
  { label: string; className: string }
> = {
  hot: {
    label: 'Hot',
    className:
      'border-primary/60 bg-primary/15 text-primary font-semibold',
  },
  warm: {
    label: 'Warm',
    className: 'border-border bg-surface text-fg-secondary font-medium',
  },
  cold: {
    label: 'Cold',
    className: 'border-border/80 bg-app/80 text-fg-muted font-medium',
  },
};

export interface LeadTemperatureBadgeProps {
  temperature: LeadTemperature;
  className?: string;
}

const LeadTemperatureBadge: React.FC<LeadTemperatureBadgeProps> = ({ temperature, className = '' }) => {
  const cfg = styles[temperature];
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs border ${cfg.className} ${className}`.trim()}
    >
      {cfg.label}
    </span>
  );
};

export default LeadTemperatureBadge;
